// extracted by mini-css-extract-plugin
module.exports = {"container":"StarredButton_container__kMLEZ"};